import { render } from "./GroupList.vue?vue&type=template&id=3153313e&scoped=true&ts=true"
import script from "./GroupList.vue?vue&type=script&lang=ts"
export * from "./GroupList.vue?vue&type=script&lang=ts"

import "./GroupList.vue?vue&type=style&index=0&id=3153313e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3153313e"]])

export default __exports__